import { render } from "./ConfirmationModal.vue?vue&type=template&id=d6c87e3a&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=d6c87e3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c87e3a"]])

export default __exports__